/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {signOut} from '../api'

export const useMutationSignOut = createReactQueryMutationHook('signOut', signOut)
